import SocialEdit from './SocialEdit';

export default SocialEdit;
